export default __webpack_public_path__ + "static/applet-08-set-1-3d51120607e474d2eee731e3da96d504.webp";